import { useState, useEffect } from "react";
import ScrollReveal from "@/components/base/ScrollReveal";

const testimonials = [
  {
    quote:
      "以前保單堆成山，根本不知道保了什麼。保險門神幫我整理出保障地圖，砍了重複的、補了缺口，每年省下快兩萬保費，保障反而變完整了。",
    name: "林小姐",
    role: "雙薪家庭主婦",
    service: "保單門神",
  },
  {
    quote:
      "做資產配置最怕市場一跌就慌。保險門神幫我設定了資金分艙和再平衡規則，現在看到新聞亂報也不會想亂動了，心裡有底很多。",
    name: "陳先生",
    role: "科技業工程師",
    service: "財產門神",
  },
  {
    quote:
      "退休規劃一直拖著沒做，怕錢不夠又怕投資虧。諮詢後把現金流、醫療緩衝區、投資現金流一層一層拆開，突然覺得好像沒那麼難了。",
    name: "王女士",
    role: "即將退休教師",
    service: "人生門神",
  },
  {
    quote:
      "公司團險買了幾年沒檢視，員工抱怨保障不夠。保險門神不只調整了團險，還順便檢視了薪資結構和勞動合約，一次解決好幾個隱患。",
    name: "張董事長",
    role: "中小企業負責人",
    service: "企業門神",
  },
  {
    quote:
      "給孩子準備教育金的過程中，順便把全家的保障和退休都一起看。以前覺得複雜的事，經過整理後變成一張清楚的藍圖。",
    name: "黃太太",
    role: "全職媽媽",
    service: "人生門神",
  },
  {
    quote:
      "保單健診後發現原本買的重大傷病險條件很舊，新的醫療技術根本不賠。幸好及早發現，調整後真正符合現在的醫療環境。",
    name: "周先生",
    role: "醫療從業人員",
    service: "保單門神",
  },
  {
    quote:
      "以前投資只看報酬率，虧錢才知道風險多重要。現在資產配置裡有預備金、有保險底層、有紀律，整個心態都穩了。",
    name: "許先生",
    role: "金融業主管",
    service: "財產門神",
  },
  {
    quote:
      "接班規劃卡在股權和家族意見不同調。保險門神從保險信託切入，先把資金流向和照護安排定好，家族會議也順利很多。",
    name: "吳老闆",
    role: "製造業二代接班人",
    service: "企業門神",
  },
];

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const cardsPerView = 3;
  const maxIndex = Math.max(0, testimonials.length - cardsPerView);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, maxIndex]);

  const goTo = (index: number) => {
    setCurrentIndex(Math.max(0, Math.min(index, maxIndex)));
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goPrev = () => goTo(currentIndex - 1);
  const goNext = () => goTo(currentIndex + 1);

  return (
    <section className="py-20 md:py-28 bg-brand-card border-y border-brand-border overflow-hidden">
      <div className="container-main">
        {/* Section Title */}
        <ScrollReveal className="text-center mb-12 md:mb-14">
          <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-3">
            客戶見證
          </h2>
          <p className="text-brand-text-secondary text-[1.0625rem] md:text-[1.1875rem] leading-[1.75]">
            他們都選擇了保險門神，看看真實的改變。
          </p>
          <div className="w-[60px] h-[2px] bg-brand-gold mx-auto mt-4" />
        </ScrollReveal>

        {/* Carousel */}
        <div className="relative">
          {/* Cards Track */}
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{
                transform: `translateX(-${currentIndex * (100 / cardsPerView)}%)`,
              }}
            >
              {testimonials.map((t, index) => (
                <div
                  key={index}
                  className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 px-3"
                >
                  <div className="bg-brand-black border border-brand-border rounded-2xl p-6 md:p-7 h-full flex flex-col transition-all duration-300 hover:border-brand-gold/40">
                    {/* Service Tag */}
                    <div className="mb-4">
                      <span className="inline-block border border-brand-border rounded-full px-3 py-1 text-brand-gold text-[0.875rem] font-medium">
                        {t.service}
                      </span>
                    </div>

                    {/* Quote */}
                    <p className="text-brand-text-secondary text-[1.0625rem] leading-[1.75] mb-6 flex-1">
                      「{t.quote}」
                    </p>

                    {/* Author */}
                    <div className="flex items-center gap-3 pt-5 border-t border-brand-border">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-gold/15 shrink-0">
                        <span className="w-5 h-5 flex items-center justify-center text-brand-gold text-sm">
                          <i className="ri-user-smile-line" />
                        </span>
                      </div>
                      <div>
                        <p className="text-white font-medium text-[1rem]">
                          {t.name}
                        </p>
                        <p className="text-brand-text-secondary text-[0.875rem]">
                          {t.role}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={goPrev}
            disabled={currentIndex === 0}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-4 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-brand-black border border-brand-border text-brand-gold hover:border-brand-gold transition-all disabled:opacity-30 disabled:cursor-not-allowed z-10 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            onClick={goNext}
            disabled={currentIndex >= maxIndex}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-4 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-brand-black border border-brand-border text-brand-gold hover:border-brand-gold transition-all disabled:opacity-30 disabled:cursor-not-allowed z-10 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`transition-all duration-300 rounded-full cursor-pointer ${
                i === currentIndex
                  ? "w-8 h-2 bg-brand-gold"
                  : "w-2 h-2 bg-brand-border hover:bg-brand-gold/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}